module.exports = __webpack_public_path__ + "static/GriegMFM.12ed9354.png";


//////////////////
// WEBPACK FOOTER
// ./src/posts/img/GriegMFM.png
// module id = 71
// module chunks = 168707334958949